import script from "./EllipsisTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./EllipsisTooltip.vue?vue&type=script&setup=true&lang=js"

import "./EllipsisTooltip.vue?vue&type=style&index=0&id=b9fbfa9a&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9fbfa9a"]])

export default __exports__